module.exports = __webpack_public_path__ + "-03_2x.jpg?0a672131c81838bed381cc6712fed7a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/-03_2x.jpg
// module id = 75
// module chunks = 0